module.exports = __webpack_public_path__ + "img/model_q.58c041d8.png";